import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import {
  Button,
  Dimmer,
  Grid,
  Loader,
  Segment,
  Header,
} from 'semantic-ui-react';

import { fetchM } from '../../actions/fetchM';
import fileSize from '../../utils/fileSize';
import { namespaces, TRANSLATION_FILES } from '../../constants/translation';

class UploadCompanyDocumentForm extends Component {
  static propTypes = {
    onSubmit: PropTypes.func,
    onChange: PropTypes.func,
    t: PropTypes.func,
    file: PropTypes.shape({
      name: PropTypes.string,
      size: PropTypes.number,
    }),
  }
  static contextTypes = {
    store: PropTypes.object,
  }
  constructor(props) {
    super(props);
    const oriUpload = props.file ? Object.assign({}, props.file) : null;
    this.state = {
      loading: false,
      oriUpload,
      upload: null,
      hasChanges: false,
    };
  }
  componentWillReceiveProps(nextProps) {
    if (this.props.file !== nextProps.file) {
      const oriUpload = nextProps.file ? Object.assign({}, nextProps.file) : this.state.oriUpload;
      this.setState({ oriUpload });
    }
  }
  setLoading = (loading = false) => new Promise((res) => {
    this.setState({ loading }, () => res(loading));
  });
  reset = cb => this.setState({ upload: null }, cb)
  submit(url, opts = {}) {
    const { store } = this.context;
    return this.setLoading(true)
      .then(() => store.dispatch(fetchM(url, opts)))
      .then(res => res.json())
      .then(result => this.setLoading(false)
        .then(() => result))
      .catch(err => this.setLoading(false)
        .then(() => Promise.reject(err)));
  }
  handleSubmit = (event) => {
    event.preventDefault();
    const { upload } = this.state;
    if (upload && upload.file) {
      const formData = new FormData(this.form);
      formData.append('file', upload.file);
      const { onSubmit } = this.props;
      if (onSubmit) {
        onSubmit(event, formData);
      }
    }
  }
  handleCheckChanges() {
    if (!this.state.hasChanges) {
      this.setState({ hasChanges: true }, () => {
        if (this.props.onChange) {
          this.props.onChange(true);
        }
      });
    }
  }
  handleOnChange = () => {
    const files = Array.prototype.slice.call(this.uploadFiles.files);
    this.uploadFiles.value = null;
    if (window.FileReader) {
      files.forEach((file) => {
        const reader = new FileReader();
        reader.onloadend = () => {
          const upload = {
            file,
            name: file.name,
            src: reader.result,
          };
          this.setState({ upload }, () => {
            this.handleCheckChanges();
          });
        };
        reader.readAsDataURL(file);
      });
    }
  }
  handleRemove = (event) => {
    event.preventDefault();
    this.setState({ upload: null });
  }
  handleAddFile = (event) => {
    event.preventDefault();
    this.uploadFiles.click();
  }
  render() {
    const { t } = this.props;
    return (
      <form
        encType="multipart/form-data"
        onSubmit={this.handleSubmit}
        name="uploadCompanyDocuments"
        ref={(ref) => { this.form = ref; }}
      >
        <input
          ref={(ref) => { this.uploadFiles = ref; }}
          type="file"
          onChange={this.handleOnChange}
          accept="application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
          style={{ display: 'none' }}
        />
        <Grid verticalAlign="middle" stackable>
          <Grid.Row columns="equal">
            <Grid.Column only="computer" />
            <Grid.Column>
              <Grid verticalAlign="middle" columns="equal">
                {
                  this.state.upload ? null : (
                    <Grid.Column>
                      <Button
                        fluid
                        compact
                        primary
                        icon="add"
                        content={t('Select File', { ns: TRANSLATION_FILES.screens })}
                        onClick={this.handleAddFile}
                        disabled={this.state.loading}
                      />
                    </Grid.Column>
                  )
                }
                <Grid.Column>
                  <Button
                    fluid
                    compact
                    type="submit"
                    positive
                    content={t('Upload', { ns: TRANSLATION_FILES.translation })} icon="cloud upload"
                    loading={this.state.loading}
                    disabled={!(this.state.upload && this.state.upload.file) || this.state.loading}
                  />
                </Grid.Column>
              </Grid>
            </Grid.Column>
          </Grid.Row>
        </Grid>
        <Grid stackable doubling columns={1}>
          <Dimmer style={{ zIndex: 20 }} active={this.state.loading} inverted>
            <Loader inline="centered">{t('Uploading', { ns: TRANSLATION_FILES.translation })}</Loader>
          </Dimmer>
          {
            (this.state.oriUpload && this.state.oriUpload.key) ? (
              <Grid.Column>
                <Header>{t('Current:', { ns: TRANSLATION_FILES.translation })}</Header>
                <Segment.Group horizontal>
                  <Segment>
                    {this.state.oriUpload.name}
                  </Segment>
                  <Segment>
                    {fileSize(this.state.oriUpload.size)}
                  </Segment>
                </Segment.Group>
              </Grid.Column>
            ) : null
          }
          {
            this.state.upload ? (
              <Grid.Column>
                <Header>{t('Selected file:', { ns: TRANSLATION_FILES.translation })}</Header>
                <Segment.Group horizontal>
                  <Segment>
                    {this.state.upload.name}
                  </Segment>
                  <Segment>
                    {fileSize(this.state.upload.file.size)}
                  </Segment>
                </Segment.Group>
              </Grid.Column>
            ) : null
          }
          {
            this.state.upload ? (
              <Grid.Column>
                <Grid stackable columns="equal">
                  <Grid.Column>
                    <Button
                      fluid
                      compact
                      primary
                      icon="add"
                      content={t('Replace', { ns: TRANSLATION_FILES.screens })}
                      onClick={this.handleAddFile}
                      disabled={this.state.loading}
                    />
                  </Grid.Column>
                  <Grid.Column>
                    <Button
                      type="button"
                      fluid
                      compact
                      icon="delete"
                      content={t('Remove', { ns: TRANSLATION_FILES.screens })}
                      negative
                      disabled={this.state.loading}
                      onClick={e => this.handleRemove(e)}
                    />
                  </Grid.Column>
                </Grid>
              </Grid.Column>
            ) : null
          }
        </Grid>
      </form>
    );
  }
}

export default withTranslation(namespaces, { withRef: true })(UploadCompanyDocumentForm);



// WEBPACK FOOTER //
// ./src/containers/CompanyDocuments/Form.jsx